import { Theme } from "@mui/system";
import { alpha } from "@mui/material";

const globalDrawerStyles = {
  stackDrawer: {
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: 1300,
    width: "300px",
  },
  stackDrawerBox: {
    textAlign: "center",
    flexGrow: 1,
    padding: "0.5rem 1rem",
  },
  drawerContentStack: {
    margin: "0.5rem",
    position: "relative",
    paddingTop: "3rem",
    maxHeight: "90vh",
  },
  drawerHeaderStack: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  },
  drawerTitleBox: {
    textAlign: "center",
    flexGrow: 1,
    // Should be same as boxIcon width to center text
    marginLeft: "96px",
  },
  boxIcon: {
    width: "96px",
  },
  drawerActions: {
    paddingBottom: "1rem",
  },
  drawerPaper: {
    width: "36.5%",
    maxWidth: "680px",
    overflow: "visible",
  },
  widePaper: {
    width: "60%",
    maxWidth: "75rem",
    height: "90vh",
  },
  highlighted: (theme: Theme) => ({
    boxShadow: `0 0 1rem 5px ${alpha(theme.palette.accent.main, .5)}`,
  }),
  drawerContent: {
    padding: "0 1rem",
    overflowY: "auto",
  },
};

export default globalDrawerStyles;
